import { Request } from '@group-devs/yfp7-global-modules'
import {useEffect} from 'react'
import { useRouter } from 'next/router'
import Head from 'next/head'
import { LETopNav, LEProgress } from '@components/Block'
import { HeroWrapper, Footer } from '@group-devs/yfp7-global-modules/components/Block'
import styles from '@group-devs/yfp7-global-modules/components/hero.module.css'
import { ProgressBar } from 'react-bootstrap'
import ReactGA from 'react-ga';

const request = new Request(process.env.apiDomain)

function Layout(props) {
  const router = useRouter()

  const site = props.global.site
  const { data: hub } = request.website.swrSite(site.accountId, "HUB")
  const { data: nav } = request.website.swrNavigation(hub ? hub.url : hub)
  const { data: tracker } = request.insights.swrTracking(site.id)

  useEffect(()=>{
    if (tracker)
    {
      if (tracker.ga_id)
      {
        ReactGA.initialize(tracker.ga_id);
        ReactGA.pageview(window.location.pathname + window.location.search);
      }
      if (tracker.matomo_id && tracker.matomoServer)
      {
        var _paq = window._paq = window._paq || [];
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        (function() {
          var u= (tracker.matomoServer.includes("http") ? "" : "//") + tracker.matomoServer.replace(/\/$/, "");
          _paq.push(['setTrackerUrl', u+'/matomo.php']);
          _paq.push(['setSiteId', tracker.matomo_id]);
          var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
          g.type='text/javascript'; g.async=true; g.src=u+'/matomo.js'; s.parentNode.insertBefore(g,s);
        })();
      }
    }
  }, [tracker])

  const title = site.name + " - Learn and Earn"
  const description = "Discover how to have long-lasting vitality and well-being with Shaklee products in my wellness center."

  return (
    <div className="page-layout wellnessCenter position-relative">
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={"Your Wellness Project, Learn and Earn, " + site.name} />
        <meta name="author" content={site.name} />
        <meta property="og:url" content={ "//" + site.url + router.asPath } key="url"/>
        <meta property="og:site_name" content={ site.name + " - Learn and Earn"} />
        <meta property="og:type" content="Website"/>
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="/themes/014-cobalt/assets/images/img/img-share02.jpg"/>
        <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap" rel="stylesheet"/>
      </Head>
      <LETopNav auth={props.global.auth} site={site} />
      <HeroWrapper  
        title="Learn and Earn Program" 
        description=""
        classname={styles.fileCabinet} />
        <div className="progressle position-absolute text-white">
          <LEProgress/>
        </div>
        {props.children}
      { nav ? <Footer host={props.global.host} site={site} navigation={nav.footer_navigation} origin="wellness"/> : null }
      <style jsx global>{`
        body{
          font-family: 'Montserrat', sans-serif;
          color:#232323;
        }
        .dropdown-item{
          color:#232323;
          padding: .25rem 1rem;
        }
        .footer__menu {
            background-color: #f7f7f7!important;
            color:#000!important;
        }
        .footer__links{
          color:#000!important;
        }
        .footer__socialLinks{
          border-color: #43a649!important;
          background-color: #43a649;
        }
        .footer__menuLinks {
            border-color:#43a649!important
        }
        .progressle{
          right: 11rem;
          top: 11.8rem;
          width: 350px;
        }
        .progressle .progress{
          height: 1rem;
        }
      `}</style>
    </div>
  )
}
  
export default Layout